import styled from 'styled-components';

export const ProducerText = styled.div`
  color: #fa8c16;
  font-weight: 500;
`;
